import { Workspace } from '@sr-sdks/api-sdk-axios';
import { UseFormReturn } from 'react-hook-form';
import { useBusinessNumberCountryDependencies } from '../fields/businessNumberCountry/useBusinessNumberCountryDependencies';
import { useCanProceedDependencies } from '../fields/canProceed/useCanProceedDependencies';
import { useContactDefaults } from '../fields/contacts/useContactDefaults';
import { useEntityTypeDependencies } from '../fields/entityType/useEntityTypeDependencies';
import { WorkspaceDetailsFormValues } from './types';

interface WorkspaceDetailsFormDependencyOptions {
  isOnboarding?: boolean;
  workspace: Workspace;
}

/**
 * Form-level dependency orchestrator (per the Modular Form Architecture doc).
 * Calls each field's reactive dependency hook and returns watched values the
 * section needs (e.g. the country, to compute the business-number label).
 */
export const useWorkspaceDetailsFormDependencies = (
  form: UseFormReturn<WorkspaceDetailsFormValues>,
  { isOnboarding = false, workspace }: WorkspaceDetailsFormDependencyOptions,
) => {
  const dependencyContext = { form };

  const entityType = useEntityTypeDependencies(dependencyContext);
  const businessNumberCountry =
    useBusinessNumberCountryDependencies(dependencyContext);

  useCanProceedDependencies(dependencyContext);
  useContactDefaults({ ...dependencyContext, isOnboarding, workspace });

  return { businessNumberCountry, entityType };
};
